import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const AUTH_STORAGE_KEY = 'sapori1989_admin_auth';

export const FooterAdminLink = () => {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminAuth = async () => {
      try {
        // First check if there's a token in localStorage
        const stored = localStorage.getItem(AUTH_STORAGE_KEY);
        if (!stored) {
          setIsAdminAuthenticated(false);
          setIsLoading(false);
          return;
        }

        const { token } = JSON.parse(stored);
        if (!token) {
          setIsAdminAuthenticated(false);
          setIsLoading(false);
          return;
        }

        // Verify token with backend
        const response = await fetch(`${BACKEND_URL}/api/admin/me`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          setIsAdminAuthenticated(true);
        } else {
          setIsAdminAuthenticated(false);
          // Clear invalid token
          localStorage.removeItem(AUTH_STORAGE_KEY);
        }
      } catch (error) {
        console.error('Error checking admin auth:', error);
        setIsAdminAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminAuth();
  }, []);

  const targetPath = isAdminAuthenticated ? '/admin/dashboard' : '/admin/login';

  if (isLoading) {
    return null; // Don't show anything while loading
  }

  return (
    <Link
      to={targetPath}
      className="inline-flex items-center gap-1.5 text-xs text-primary-foreground/40 hover:text-primary-foreground/70 transition-colors"
    >
      <User className="w-3 h-3" />
      <span>Area Ristorante</span>
    </Link>
  );
};
